import React from 'react';
import PropTypes from 'prop-types';
import BaseLayout from './BaseLayout';
import BasicPage from './BasicPage';

function Layout({
  header,
  title: providedTitle,
  dontUseBasicPage = false,
  content: providedContent,
  children,
  mainPanelStyle,
  noHeader = false,
  navItems,
  userNavItems,
  app,
  search,
  success,
  error,
  action,
}) {
  let customHeader;
  let title;

  if (header) {
    customHeader = header;
  } else {
    title = providedTitle;
  }

  const content = children || providedContent;

  return (
    <BaseLayout
      mainPanelStyle={mainPanelStyle}
      noHeader={noHeader}
      navItems={navItems}
      userNavItems={userNavItems}
      app={app}
      search={search}
      success={success}
      error={error}
    >
      {customHeader}
      {dontUseBasicPage && content}
      {!dontUseBasicPage && (
        <BasicPage title={title} action={action}>
          {content}
        </BasicPage>
      )}
    </BaseLayout>
  );
}

Layout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dontUseBasicPage: PropTypes.bool,
  content: PropTypes.node,
  children: PropTypes.node,
  mainPanelStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  noHeader: PropTypes.bool,
  navItems: PropTypes.node,
  userNavItems: PropTypes.node,
  app: PropTypes.string,
  search: PropTypes.node,
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  action: PropTypes.node,
};

Layout.defaultProps = {
  header: null,
  title: null,
  dontUseBasicPage: false,
  content: null,
  children: null,
  mainPanelStyle: undefined,
  noHeader: false,
  navItems: null,
  userNavItems: null,
  app: undefined,
  search: null,
  success: null,
  error: null,
  action: null,
};

export default Layout;
